<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Device Diagnostic Payload Mapping</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="()=>{selectedMap=null; dialogSwitch = true}">
                    Add
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Profile</th>
                        <th>Module Index</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="map in maps" v-if="maps.length" :key="map.id" class="text-left">
                        <td>{{ map.name }}</td>
                        <td>{{ map.profile }}</td>
                        <td>{{ map.module_index }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn class="text-warning" size="x-small"
                                       @click="editMap(map)">Edit
                                </v-btn>
                                <v-btn class="text-error" size="x-small"
                                       @click="deleteMap(map)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="4">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="4">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @update:model-value="fetchMaps"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Create_Edit v-if="dialogSwitch"
                 v-model="dialogSwitch"
                 :map="selectedMap"
                 @addMap="addMap"
                 @updateMap="updateMap"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Create_Edit from "@/components/dialogs/devices/diagnostics/Payload_Mapping_Create_Edit.vue";

const maps = ref([]);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const selectedMap = ref(null);
const dialogSwitch = ref(false);
const {showSnackbar} = useSnackbarStore();

onMounted(() => {
    fetchMaps();
});

const fetchMaps = () => {
    send('get', `admin/diagnostics/payload-mappings`, {page: currentPage.value})
        .then((response) => {
            maps.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Device diagnostic payload mapping could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addMap = (map) => {
    maps.value.unshift(map);
}
const editMap = (map) => {
    selectedMap.value = map;
    dialogSwitch.value = true;
}
const updateMap = (map) => {
    maps.value.map((item, index) => {
        if (item.id === map.id) {
            maps.value[index] = map;
        }
    });
}
const deleteMap = (map) => {
    if (confirm(`Are you sure to delete "${map.title}" map?`)) {
        send('delete', `admin/diagnostics/payload-mappings/${map.id}`)
            .then((response) => {
                if (response.data.success) {
                    maps.value.map((item, index) => {
                        if (item.id === map.id) {
                            maps.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${map.title}" device diagnostic payload mapping could not be deleted`, 'error')
                }
            })
    }
}
</script>
